import React from 'react';
import { CheckCircle2 } from 'lucide-react';

interface IntegrationCardProps {
  title: string;
  icon: React.ReactNode;
  description: string;
  connectedDescription?: string;
  isConnected: boolean;
  activeEmail?: string | null;
  onConnect: () => void;
  onDisconnect: () => void;
}

export function IntegrationCard({
  title,
  icon,
  description,
  connectedDescription,
  isConnected,
  activeEmail,
  onConnect,
  onDisconnect
}: IntegrationCardProps) {
  const displayDescription = isConnected
    ? (connectedDescription || (activeEmail ? `Connected as ${activeEmail}` : 'Connected'))
    : description;

  return (
    <div 
      style={{
        borderRadius: '0',
        padding: '16px 20px',
        border: isConnected ? '1px solid rgba(34, 197, 94, 0.35)' : '1px solid var(--admin-card-border)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: '16px',
        backgroundColor: isConnected ? 'rgba(34, 197, 94, 0.06)' : 'var(--admin-card-bg)',
        transition: 'all 0.2s'
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: '16px', flex: '1 1 240px', minWidth: 0 }}>
        <div style={{
          width: '44px',
          height: '44px',
          borderRadius: '0',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: 'rgba(255, 255, 255, 0.02)',
          border: isConnected ? '1px solid rgba(34, 197, 94, 0.3)' : '1px solid var(--admin-card-border)',
          flexShrink: 0
        }}>
          {icon}
        </div>
        <div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
            <h3 style={{ fontFamily: "'Space Grotesk', sans-serif", fontWeight: 700, fontSize: '16px', color: 'var(--admin-card-text)', margin: 0 }}>
              {title}
            </h3>
            {isConnected && (
              <span style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '4px',
                fontSize: '10px',
                fontWeight: 700,
                padding: '2px 8px',
                borderRadius: '0',
                backgroundColor: 'rgba(34, 197, 94, 0.15)',
                border: '1px solid rgba(34, 197, 94, 0.35)',
                color: '#4ade80',
                letterSpacing: '0.04em',
                textTransform: 'uppercase'
              }}>
                <CheckCircle2 size={11} /> Connected
              </span>
            )}
          </div>
          <p style={{ fontFamily: "'Inter', sans-serif", fontSize: '12px', color: 'var(--admin-card-subtext)', margin: '4px 0 0' }}>
            {displayDescription}
          </p>
        </div>
      </div>

      <button 
        type="button"
        onClick={isConnected ? onDisconnect : onConnect}
        style={{
          padding: '8px 22px',
          borderRadius: '0',
          fontSize: '13px',
          fontWeight: 700,
          fontFamily: "'Inter', sans-serif",
          cursor: 'pointer',
          backgroundColor: isConnected ? 'transparent' : '#ffffff',
          color: isConnected ? '#ef4444' : '#000000',
          border: isConnected ? '1px solid #ef4444' : 'none',
          boxShadow: isConnected ? 'none' : '0 1px 2px rgba(0,0,0,0.1)',
          transition: 'all 0.2s'
        }}
      >
        {isConnected ? 'Disconnect' : 'Connect'}
      </button>
    </div>
  );
}
